(function ($) {
    $(document).ready(function () {
        fixed_size();
    });
    $(window).resize(function () {
        fixed_size();

    });
    function fixed_size() {
        var window_width = $(window).width();
        var tag_height = $('body .content-with-image .col-wrap .content-wrapper .col-inner').height() + 280;
        if (window_width <= 767) {
            $('body .content-with-image .col-wrap .content-wrapper').css({'height': tag_height + 'px'});
        }
        else {
            $('body .content-with-image .col-wrap .content-wrapper').css({'height': 'auto'});

        }

    }
})(jQuery);